import { render, staticRenderFns } from "./tnc-es.vue?vue&type=template&id=79bf2403&scoped=true"
import script from "./tnc-es.vue?vue&type=script&lang=js"
export * from "./tnc-es.vue?vue&type=script&lang=js"
import style0 from "./tnc-es.vue?vue&type=style&index=0&id=79bf2403&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf2403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bf2403')) {
      api.createRecord('79bf2403', component.options)
    } else {
      api.reload('79bf2403', component.options)
    }
    module.hot.accept("./tnc-es.vue?vue&type=template&id=79bf2403&scoped=true", function () {
      api.rerender('79bf2403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-es.vue"
export default component.exports